import React from 'react';

/*
  LetsCampaign logo mark: the "L" and "C" use currentColor, so they are black
  on the Light theme and white on Dark; the bars stay brand blue in both.
  Same shapes as public/brands/letscampaign/favicon.svg and the letscampaign.com
  header.
*/
export function LetsCampaignMark({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
      <path d="M6 4.85h3.6a3 3 0 0 1 3 3V43.4a6.9 6.9 0 0 0 6.9 6.9h.9l7.7 7.9-.1.7H17.4A14.4 14.4 0 0 1 3 44.5V7.85a3 3 0 0 1 3-3Z" fill="currentColor" />
      <path d="M58.38 14.62A23.3 23.3 0 1 0 59.22 46.69" fill="none" stroke="currentColor" strokeWidth="8" />
      <rect x="28.8" y="29.5" width="8.4" height="11.9" rx="2.2" fill="#2160ff" />
      <rect x="39" y="25.8" width="8.2" height="15.7" rx="2.2" fill="#2160ff" />
      <rect x="49.2" y="19.8" width="8.9" height="21.7" rx="2.2" fill="#2160ff" />
    </svg>
  );
}

export default LetsCampaignMark;
